import styled from "styled-components";
export const Styles = styled.div`
  .video-container {
    position: relative;
    border-radius: 7px;
    overflow: hidden;
    border: 1px solid #c2c2d498;
  }
  .video-container .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 7px;
  }
  .video-container .bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: blur(5px);
  }
  .avatar {
    ${(props) =>
      props.usersCount > 2
        ? `width: 100px;
    height: 100px;`
        : `width: 150px;
    height: 150px;`}
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 35px;
    color: #fff;
    background: #c2c2d498;
    border: 2px solid #c2c2d498;
  }
  .swiper .avatar {
    width: 75px;
    height: 75px;
  }
  .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .data {
    position: absolute;
    left: 0;
    bottom: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-inline: 40px;
    color: #fff;
  }
  .info {
    position: absolute;
    left: 50%;
    top: 10px;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--dark-purple);
    padding: 10px;
    border-radius: 35px;
    padding-inline: 40px;
    color: #fff;
    white-space: nowrap;
    ${(props) =>
      props.usersCount > 2 ? `font-size: 12px;` : `font-size: 14px;`}
    transition:.3s;
  }
  .my-video-container .info.hand-up {
    top: 5px;
    font-size: 11px;
    padding: 10px;
    left: auto;
    right: 40px;
    transform: translate(0, 0);
  }
  .my-video-container .info.hand-up.ar {
    right: auto;
    left: 40px;
    transform: translate(0, 0);
  }
  .swiper .info {
    top: 10px;
    padding: 5px;
    padding-inline: 20px;
    font-size: 11px;
  }
  .swiper .data {
    bottom: 0px;
    padding-inline: 10px;
    bottom: 20px;
    font-size: 11px;
  }
  .data .user-name {
    background: #c2c2d498;
    padding: 10px;
    border-radius: 35px;
  }
  .data .volume .btn {
    background-color: #c2c2d498 !important;
    border-color: #c2c2d498 !important;
    border-radius: 35px !important;
    margin: 0 !important;
  }
  .data .volume .btn:hover {
    background-color: var(--dark-purple) !important;
    color: #c2c2d498 !important;
  }
  @media (max-width: 768px) {
    .info {
      top: 10px;
      padding: 5px;
      padding-inline: 20px;
      font-size: 13px;
    }
    .data {
      bottom: 0px;
      padding-inline: 10px;
      font-size: 13px;
    }
  }
  .full-screen-loading {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    width: 0%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 23px;
    color: transparent;
    transition: all 0.3s;
  }
  .full-screen-loading::before {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    width: 100%;
    height: 100%;
    content: "";
    background: #000000;
    opacity: 0.8;
    z-index: -1;
  }
  .full-screen-loading.show {
    width: 100%;
    z-index: 2;
    color: #fff;
    z-index: 1000;
  }
  .full-screen-loading .spinner-border {
    border: 2px solid transparent !important;
    border-left-color: transparent !important;
  }
  .full-screen-loading.show .spinner-border {
    border: 2px solid #fff !important;
    border-left-color: transparent !important;
  }
  .is-hand-raised {
    position: absolute;
    left: -1000px;
    top: 5px;
    background: rgba(194, 194, 212, 0.596);
    padding: 10px;
    border-radius: 35px;
    font-size: 11px;
    color: var(--dark-color);
    opacity: 0;
    transition: 0.3s;
  }
  .is-hand-raised.hand-up {
    opacity: 1;
    left: 40px;
  }
  .is-hand-raised.ar {
    left: auto;
    right: -1000px;
  }
  .is-hand-raised.hand-up.ar {
    opacity: 1;
    left: auto;
    right: 40px;
  }
  @media (max-width: 768px) {
    .my-video-container .info {
      top: 5px;
      font-size: 11px;
      padding: 10px;
      left: auto;
      right: 40px;
      transform: translate(0, 0);
    }
    .my-video-container .info.ar {
      right: auto;
      left: 40px;
      transform: translate(0, 0);
    }
  }

  /* big blue button meeting  */
  .bbb-meeting {
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }
  .bbb-meeting iframe {
    width: 100%;
    height: 100%;
  }
  @media (max-width: 992px) {
    .bbb-meeting {
      margin-top: 0px;
    }
  }
`;
